module.exports = __webpack_public_path__ + "assets/img/thumb-Spark-Systems-Website.00db29cd.webp";